import { CSMapCoordinates } from 'components/discovery/store-locator/typing/internal.js'
import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'

export const STORE_LOCATOR_API = Symbol('STORE_LOCATOR_API')

export class StoreLocatorGetRequest {
  endpointUrl: URL
  method = 'GET' as const
  headers: HeadersInit = { Accept: 'application/json' }
  controller: AbortController = new AbortController()

  constructor(endpoint: string, coordinates: CSMapCoordinates | null = null) {
    this.endpointUrl = new URL(endpoint, window.location.href)
    if (coordinates) {
      this.endpointUrl.searchParams.set('latitude', coordinates.location.latitude.toString())
      this.endpointUrl.searchParams.set('longitude', coordinates.location.longitude.toString())
    }
  }
}

@registerDependency(FAKE, STORE_LOCATOR_API)
export class FakeStoreLocatorApi {

  stores: unknown
  requests: StoreLocatorGetRequest[] = []

  getStores(request: StoreLocatorGetRequest) {
    this.requests.push(request)
    return Promise.resolve(this.stores)
  }
}

@registerDependency(REAL, STORE_LOCATOR_API)
export class StoreLocatorApi {
  getStores = async (request: StoreLocatorGetRequest): Promise<unknown> => {
    const response = await fetch(request.endpointUrl, {
      method: request.method,
      headers: request.headers
    })

    return await response.json()
  }
}
